// Nome do produto de exemplo semeado em toda conta nova (ver Cadastro.jsx ->
// semearContaNova). Compartilhado com o tutorial guiado (useTour.js /
// TourPdvInteractive.jsx), que usa esse nome pra encontrar o produto certo
// no PDV durante a demonstração interativa — por isso mora num arquivo à
// parte em vez de ficar hardcoded duas vezes.
export const PRODUTO_DEMO_NOME = "🧪 Produto de exemplo — Vaso Geométrico PLA";
